import { render, staticRenderFns } from "./RegisterSensorNode.vue?vue&type=template&id=2aa83c57&scoped=true"
import script from "./RegisterSensorNode.vue?vue&type=script&lang=js"
export * from "./RegisterSensorNode.vue?vue&type=script&lang=js"
import style0 from "./RegisterSensorNode.vue?vue&type=style&index=0&id=2aa83c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa83c57",
  null
  
)

export default component.exports